<template>
    <div class="c-app flex-row align-items-center login">
      <CContainer>
        <CRow class="justify-content-center">
          <CCol class="col-12">
            <CAlert color="danger" closeButton :show.sync="loginError">
              {{ loginError }}
            </CAlert>
  
            <div class="col-12 p-0 m-auto tablet-bg-12 tablet-sm-8">
              <CCard class="border-card col-5 tablet-bg-8 mx-auto card--custom
                  animate__animated animate__fadeIn " >
                <CCardBody>
                  <div class="card-header mb-4 pb-0">
                    <h1 class="text-center">Bienvenido</h1>
                    <h4 class="text-center mb-3">Ingresa a tu cuenta</h4>
                  </div>
                  <CForm @submit.prevent="checkForm" class="p-3">
                    <div class="input-group mb-3" style="border-radius: 30%;">
                      <button class="btn btn-outline-secondary border-button" type="button" id="button-addon1" disabled><i class="far fa-user"></i></button>
                      <input type="text" class="form-control" v-model="usuario.userName" placeholder="Usuario" autocomplete="username">
                    </div>
                    <div class="input-group mb-3" style="border-radius: 30%;">
                      <button class="btn btn-outline-secondary border-button" type="button" id="button-addon1" disabled><i class="fas fa-unlock"></i></button>
                      <input type="password" class="form-control" v-model="usuario.password" placeholder="Password" autocomplete="curent-password">
                    </div>
  
                    <div class="login__errors">
                      <div
                        class="
                          alert alert-danger
                          animate__animated animate__slideInUp animate__faster
                        "
                        v-for="(error, i) in errors"
                        :key="i"
                      >
                        {{ error }}
                      </div>
                    </div>
  
                    <div class="form-group mt-4 d-flex justify-content-center">
                      <button style="border-radius: 15px; height: 40px;"
                        class="btn btn-primary--custom flex-grow-1 mt-2"
                        @click="coverLoading"
                      >
                        Iniciar sesión
                      </button>
                    </div>
                    <!-- <div class="text-center mb-3 fs-14">
                      <div>
                        <p class="mt-4 mb-0">¿Olvidaste tu contraseña?</p>
                        <a
                          @click="recuperarPasswoord"
                          class="text-primary--custom text-underline pointer"
                          >Recupera el acceso a tu cuenta</a
                        >
                      </div>
                    </div>
                    <div class="text-center card-footer fs-14">
                      <div>
                        <p class="mt-1 mb-0">¿No tienes cuenta?</p>
                        <a  class="text-primary--custom text-underline pointer" @click="registro">Registrate</a>
                      </div>
                    </div> -->
                  </CForm>
                </CCardBody>
              </CCard>
            </div>
          </CCol>
        </CRow>
      </CContainer>

      <!-- <RegistrateModal
      @formularioCompletado="manejarFormulario"
      :onChangeFile="onChangeFile"
      :getCP="getCP"
      :file.sync="file"
      :validCP.sync="validCP"
      :colonias.sync="colonias"
      :estado_s.sync="estado"
      :municipio_s.sync="municipio"
      :cleanModal.sync="cleanModal"
      ref="hijo"
      />
      <MensajeModal 
      :Icon="icono"
      :Title="title"
      :Text="text"
      :ClassButton="classButton"
      :actionButton="actionButton"
      />
      <RecuperarPassword
      @RFCPassword="sendPassword"
      :invalidRFC="invalidRFC"
      /> -->
      <Loading :isLoading="isLoading"/>
    </div>
  </template>
  
  <script>
  import { mapActions, mapState } from "vuex";
  import Loading from './Tools/loading.vue';
//   import RegistrateModal from "../sasp/Modals/registrateModal.vue";
//   import MensajeModal from './Modals/mensajeModal.vue';
//   import RecuperarPassword from './Modals/recuperarContrasenaModal.vue';

  export default {
    components: {
        Loading,
        // RegistrateModal,
        // MensajeModal,
        // RecuperarPassword
    },
    data() {
      return {
        isLoading: false,
        //Recuperarar contraseña
        rfcPassword: '',
        invalidRFC: false,
        //Modal validacion
        icono: 0,
        title: '',
        text: '',
        classButton: '',

        showModal: true,
        errors: [],
        usuario: {
          userName: "",
          password: "",
        },
        showModal: false,
        expression: /^[A-Za-z0-9!@#$%^&*()_+{}|:"<>?~\-\[\]\\;',./]+$ /,
        //data Registrate
        usuarioSASP: {
            userName: "900650",
            password: "123456",
        },
        file: [],
        colonias: [],
        datosFormularios: {},
        validCP: true,
        municipio: '',
        estado: '',
        cleanModal: false,
      };
    },
    methods: {
      actionButton(){
        this.$modal.hide('mensaje')
    },
      //Metodos recuperar contraseña
      recuperarPasswoord(){
        this.$modal.show('recuperar-contrasena')
        this.$store.dispatch("loginExtern", this.usuarioSASP);
      },
      async sendPassword(rfc){
        this.rfcPassword = rfc
        if (this.rfcPassword == '') {
          this.$modal.show('mensaje')
          this.$modal.hide('recuperar-contrasena')
          this.icono = 2
          this.title = 'Error!'
          this.text = 'Debe ingresar un RFC valido.'
          this.classButton = 'btn btn-danger col-3'
          return;
        }
        this.isLoading = true;
        const payload = {
            metodo: "GETUSERFULL",
            data: {
              usuario: this.rfcPassword,
              tipobusqueda: "2"
            },
        };
        this.$store.dispatch("metodoPost", payload).then(() => {
        const info = this.$store.getters.getRespuestaREST;
        if (info == '') {
          let error = this.$store.getters.getDataRaw.errorMessage
          this.$modal.show('mensaje')
          this.$modal.hide('recuperar-contrasena')
          this.icono = 2
          this.title = 'Error!'
          this.text = error
          this.classButton = 'btn btn-danger col-3'
        } else {
          
          let email = info.contactos[0].valor
          const atIndex = email.indexOf('@');
          if (atIndex <= 3) this.text = email;
          const start = email.slice(0, 3);
          const masked = '*'.repeat(atIndex - 3);

          this.$modal.show('mensaje')
          this.$modal.hide('recuperar-contrasena')
          this.icono = 1
          this.title = 'La contraseña sera enviada al correo:'
          this.text = `${start}${masked}${email.slice(atIndex)}`
          this.classButton = 'btn btn-success col-3'
          this.desencriptarPassword(info.usuario.password, email)
        }
        this.isLoading = false;
        })
      },
      async desencriptarPassword(password, email){
        this.isLoading = true;
        const payload = {
            metodo: "DECRYPTPASSWORD",
            data: {
              valorin: password,
              valorout: '',
              tipo: "2"
            },
        };
        this.$store.dispatch("metodoPost", payload).then(() => {
        const info = this.$store.getters.getRespuestaREST;
        console.log(info);
        this.emailPassword(info.valorout, email)
        })
        this.isLoading = false;
      },
      async emailPassword(pass, email){
        this.isLoading = true;
        const payload = {
              metodo: "SENDEMAILSAS",
              data: {
                idTemplate:"100",
                sender:"tramites.sasp@latinoseguros.com.mx",  //correo de donde sale
                subject: "Recuperación de contraseña",
                targets: email,  //correo a donde llega
                dinamicContent: `${pass}`,     
                idMessage:"100"   //id de plantilla
              },
            };
          this.$store.dispatch("metodoPost", payload).then(() => {
          const info = this.$store.getters.getRespuestaREST;
          console.log(info);
          })
          this.isLoading = false;
      },
      //Metodos Registrarse
      onChangeFile(event){
          this.file.push(event.target.files[0])
      },
      async getCP(event){
        this.colonias = []
          console.log(event.target.value.length);
          if (event.target.value.length === 5) {
            this.validCP = true
            this.isLoading = true;
            const payload = {
              metodo: "GETINFOCP",
              data: {
                CP: event.target.value,
              },
            };
          this.$store.dispatch("metodoPost", payload).then(() => {
          const info = this.$store.getters.getRespuestaREST;
          this.municipio = info[0].NombreMunicpio
          this.estado = info[0].NombreEstado
          info.map( (i) => {
            this.colonias.push( {
              label: i.NombreColonia,
              value: i.ClaveColonia,
            })
          })
          })
          } else {
            this.validCP = false
          }
          this.isLoading = false;
      },
      validacionFormulario(){
        console.log('entra validaciones');
        switch (this.datosFormularios.Tipo) {
          case '1':
            if (this.datosFormularios.RFC == '' ||  this.datosFormularios.Razon_Social == '' || 
                this.datosFormularios.Nombre_Comercial == '' || this.datosFormularios.Email == '')  {
                  this.$modal.show('mensaje')
                  this.icono = 2
                  this.title = 'Error!'
                  this.text = 'Todos los campos son obligatorios'
                  this.classButton = 'btn btn-danger col-3'
                  return false
            }
            break;
          case '2':
          if (this.datosFormularios.RFC == '' ||  this.datosFormularios.Nombre_s == '' || 
                this.datosFormularios.Apellido_Materno == '' || this.datosFormularios.Apellido_Paterno == ''
                || this.datosFormularios.Email == '' || this.datosFormularios.Telefono == ''
                || this.datosFormularios.Proveedores == '')  {
                  this.$modal.show('mensaje')
                  this.icono = 2
                  this.title = 'Error!'
                  this.text = 'Todos los campos son obligatorios'
                  this.classButton = 'btn btn-danger col-3'
                return false
            }
            break;
          case '3':
          if (this.datosFormularios.Tipo_Persona == '' ||  this.datosFormularios.RFC == ''
              || this.datosFormularios.Email == '' || this.datosFormularios.Telefono == '')  {
                if(this.datosFormularios.Tipo_Persona == '1'){
                  if(this.datosFormularios.Nombre_s == '' ||  this.datosFormularios.Apellido_Paterno == '' || this.datosFormularios.Apellido_Materno == '' ){
                    this.$modal.show('mensaje')
                    this.icono = 2
                    this.title = 'Error!'
                    this.text = 'Todos los campos son obligatorios'
                    this.classButton = 'btn btn-danger col-3'
                    return false
                  }
                }
                if(this.datosFormularios.Tipo_Persona == '2'){
                  if(this.datosFormularios.Razon_Social == '' ||  this.datosFormularios.Nombre_Comercial == ''){
                    this.$modal.show('mensaje')
                    this.icono = 2
                    this.title = 'Error!'
                    this.text = 'Todos los campos son obligatorios'
                    this.classButton = 'btn btn-danger col-3'
                    return false
                  }
                }
              return false
            }
            break;
          default:
            break;
        }
        return true;
        // if(this.datosFormularios.Tipo == 1){

        // }
      },
      async manejarFormulario(datosFormularios) {
        this.datosFormularios = datosFormularios // Manejar los datos recibidos del formulario hijo
        console.log(this.datosFormularios);
        if (this.validacionFormulario()) {
          if(this.datosFormularios.Proveedores == 'Si') { this.emailProveedores() }
          this.isLoading = true;
          const payload = {
          metodo: "REGISTROUSUARIO",
          data: {
            Usuario: {
                IdSexo: 0,
                IdTipoPersona: this.datosFormularios.Tipo_Persona, //1 PERSONA FÍSICA , 2PERSONA MORAL
                IdEstadoCivil: 0,
                IdArea: 25, //siniestro personas 25
                IdTipoUsuario: 7, //Para pago a provedores es el 7
                IdUsuarioApp: "",  //no se manda
                Nombre: this.datosFormularios.Nombre_s || this.datosFormularios.Nombre_Comercial,  //para razon socialtodo sobre el nombre
                Apaterno: this.datosFormularios.Apellido_Paterno,
                Amaterno: this.datosFormularios.Apellido_Materno,
                Usuario: this.datosFormularios.RFC, //obligatorio  rfc
                Password: "",
                ConfirmacionPassword: "",
                RutaFoto: "",
                Activo: 1,
                IdRool: 20056, //para proveedor
                RFC: this.datosFormularios.RFC
            },
            DomicilioUsuario: [
                { //lista de domicilio
                    Calle: null,
                    NumExterior: null,
                    NumInterior: null,
                    IdEstado: 0,
                    Estado: null,
                    IdMunicipio: 0,
                    Municipio: null,
                    IdColonia: 0,
                    Colonia: null,
                    Cp: null
                }
            ],
            ContactoUsuario: [ //lista de contacto
                {
                    TIPOCONTACTO: 3, //- 1    TELÉFONO PRINCIPAL  2 TELÉFONO ECUNDARIO 3 CORREO ELECTRÓNICO
                    VALOR: this.datosFormularios.Email
                },
                {
                    TIPOCONTACTO: 1,
                    VALOR: this.datosFormularios.Telefono
                }
            ],
            Validaciones: {
                ValidaEmail: true,
                ValidaRfc: true,
                ValidaPassIgual: false,
                AplicaSeguridadPassword: false,
                ValidaCondiciones: true,
                GeneraPassword: true,
                ValidaGeneraCorreoConPass: true,
                ValidaGeneraCodigoVerificador: false
            },
            DatosProveedor: {
              DatosGenerales: {
                  IDTITULO: 3, //SERVICIOS MÉDICOS SINIESTROS PERSONAS
                  IDPRODUCCIONECONOMICA: 1, //Servicios
                  IDONBASE: "",
                  IDSISE: "",
                  IDINVITACION: "",
                  TIPOPERSONA: this.datosFormularios.Tipo_Persona == 1 ? 'Persona Fisica' : this.datosFormularios.Tipo_Persona == 2 ? 'Persona Moral' : '', //persona moral o  persona fisica
                  IDOCUPACIONPROF: 0,
                  OCUPACIONPROF: "",
                  ESTADOCIVIL: "",
                  SEXO: "",
                  IDNACIONALIDAD: 155, //155 MEXICO
                  NACIONALIDAD: "MEXICO",
                  IDPAIS: 0,
                  PAIS: "",
                  FECHANAC: "1900-01-01",
                  LUGARNAC: "",
                  CURP: "",
                  NOMBRECORTO: this.datosFormularios.Nombre_Comercial  //nombre comercial
              }
            }
          },
          };
          
          try {
          const response = await this.$store.dispatch("metodoPost", payload);
              if (response) {
                  const res = this.$store.getters.getRespuestaREST[0];
                  console.log(res);
                  this.$modal.show('mensaje')
                  this.icono = 1
                  this.title = 'Exito!'
                  this.text = 'Usuario registrado exitosamente'
                  this.classButton = 'btn btn-success col-3'
                  this.$modal.hide('registro')
                  
                  const componenteHijo = this.$refs.hijo;
                  componenteHijo.limpiarControles();
              } else {
                let error = this.$store.getters.getDataRaw.errorMessage
                this.$modal.show('mensaje')
                  this.icono = 2
                  this.title = 'Error!'
                  this.text = error
                  this.classButton = 'btn btn-danger col-3'
              }
          } //Fin try
          catch (error) {
              console.log(error);
          }
        }
        this.isLoading = false;
        },
      async emailProveedores(){
        let nombre = ''
        if(this.datosFormularios.Nombre_s == ''){
          nombre = this.datosFormularios.Razon_Social
        } else {
          nombre = `${this.datosFormularios.Nombre_s} ${this.datosFormularios.Apellido_Paterno} ${this.datosFormularios.Apellido_Materno}`
        }
        this.isLoading = true;
        const payload = {
              metodo: "SENDEMAILSAS",
              data: {
                idTemplate:"99",
                sender:"tramites.sasp@latinoseguros.com.mx",  //correo de donde sale
                subject: "Registro Red Médica Latino",
                targets: "redmedicalatino@latinoseguros.com.mx",  //correo a donde llega
                dinamicContent: `${nombre} | ${this.datosFormularios.Email} | ${this.datosFormularios.Telefono} `,     
                idMessage:"99"   //id de plantilla
              },
            };
          this.$store.dispatch("metodoPost", payload).then(() => {
          const info = this.$store.getters.getRespuestaREST;
          console.log(info);
          })
          this.isLoading = false;
      },
      
      //Metodos Login
      registro(){
        this.$modal.show('registro')
        this.$store.dispatch("loginExtern", this.usuarioSASP);
      },
      checkForm: function (e) {
        this.errors = [];
        if (!this.usuario.userName) this.errors.push("Usuario requerido");
        if (!this.usuario.password) {
          this.errors.push("Password requerido");
          this.coverLoading(false);
        } else if (
          this.usuario.password.length < 3
        ) {
          this.errors.push("Password Invalido");
          this.coverLoading(false);
        }
        if (!this.errors.length) {
          this.isLoading = true;
          this.$store.dispatch("loginISEP", {usuario: this.usuario});
          this.isLoading = false;
          this.$store.commit('disabledLoading')
        } else {
          e.preventDefault();
          return true;
        }
      },
      coverLoading(show = true) {
        this.$store.state.Loading = true;
        if (!show) {
          this.$store.state.Loading = false;
        }
      },
    },
    computed: {
      ...mapState(["loggingIn", "loginError", "loginSuccessful"]),
    },
    mounted () {
        // this.$modal.show('mensaje')
    }
  };
  </script>
  <style scoped>
  .border-card{
    border-radius: 30px !important;
  }
  input {
    border-top-right-radius: 15px !important; 
    border-bottom-right-radius: 15px !important; 
    height: 50px !important;
  }
  .border-button {
    border-top-left-radius: 15px; 
    border-bottom-left-radius: 15px; 
    /* height: 50px; */
  }
  .card-header{
    color: rgb(240, 243, 255) !important;
  }
  .vm--modal {
  border-radius: 90px !important;
  }
  </style>
  